import { COVER_TYPE_IMAGE, COVER_TYPE_TEMPLATE } from './Cover'
import { ImageCover } from './ImageCover'
import { TemplateCover } from './TemplateCover'

/*
  Выбирает реализацию обложки по данным проекта.

  Если тип не задан явно, режим выводится из данных:
  - у существующих проектов обложка — загруженные картинки → image;
  - иначе, когда для формата книги есть шаблон обложки, — template (дефолт для новых);
  - без доступного шаблона остаётся image (страховка для форматов без обложек и
    контекстов, где coverTemplate не загружен).
*/
class CoverFactory {
  static resolveType (project) {
    const data = project?.cover || {}

    if (data.type) return data.type
    if (data.left || data.right) return COVER_TYPE_IMAGE

    return project?.coverTemplate ? COVER_TYPE_TEMPLATE : COVER_TYPE_IMAGE
  }

  static create (project) {
    const data = project?.cover || {}

    if (CoverFactory.resolveType(project) === COVER_TYPE_TEMPLATE) {
      return new TemplateCover(project, data)
    }

    return new ImageCover(project, data)
  }
}

export { CoverFactory }
